import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { url } from '../../../config';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, fontWeightBold, linkText } from '../../../helpers/getEmailStyles';

class BookingConfirmationGuest extends Component {
	static propTypes = {
		content: PropTypes.shape({
			guestName: PropTypes.string.isRequired,
			listTitle: PropTypes.string.isRequired,
			listCity: PropTypes.string.isRequired,
			threadId: PropTypes.number.isRequired,
		}).isRequired
	};

	render() {
		const { content: { guestName, listTitle, listCity, threadId, logo, siteName, checkIn, checkOut } } = this.props;
		let contactURL, checkInDate, checkOutDate
		contactURL = url + '/message/' + threadId + '/guest';
		checkInDate = checkIn != null ? moment(checkIn).format('ddd, Do MMM, YYYY') : ''
		checkOutDate = checkOut != null ? moment(checkOut).format('ddd, Do MMM, YYYY') : ''
		return (
			<Layout>
				<Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
				<div style={body}>
					<EmptySpace height={20} />
					<div style={fontWeightBold}>
						Bonjour {guestName},
					</div>
					<EmptySpace height={20} />
					<div>
						Merci d'avoir choisi {siteName} pour votre séjour à {listCity} ! Nous avons le plaisir de confirmer votre réservation à {listTitle} du {checkInDate} au {checkOutDate}.
					</div>
					<EmptySpace height={20} />
					<div>
						Veuillez procéder au paiement en visitant votre <a href={url + '/inbox'} style={{color: PRIMARY_COLOR, textDecoration: 'none'}}>boîte de réception</a> pour finaliser votre réservation.
					</div>
					<EmptySpace height={20} />
					<div>
						Nous espérons que vous passerez un excellent séjour ! Si vous avez besoin de quoi que ce soit, n'hésitez pas à contacter votre hôte.
					</div>
					<div>
						<a style={linkText} href={contactURL}>Contacter l'hôte</a>
					</div>
					<EmptySpace height={20} />
					<EmailSignature siteName={siteName} />
				</div>
				<EmptySpace height={40} />
				<Footer siteName={siteName} />
				<EmptySpace height={20} />
			</Layout>
		);
	}
}

export default BookingConfirmationGuest;